// extracted by mini-css-extract-plugin
export default {"header":"ActivitiesPage_header__hYamm","filters":"ActivitiesPage_filters__WVNzB","root":"ActivitiesPage_root__t5mNR","body":"ActivitiesPage_body__GgzhQ"};